module.exports = __webpack_public_path__ + "static/media/backgroundImg.2c0de1a1.svg";